import {Piatto} from "../interfaces/piatto";
import {db} from "../script/Fetch";
import FirestoreDbQueries from "./FirestoreDbQueries";

export default class PiattoDbQueries extends FirestoreDbQueries<Promise<Piatto>> {
    listener?: () => void;
    piattoList: { [key: string]: Piatto; } = {};

    startListenPiattiByRistoranteId(ristoranteId: string) {
        this.listener = db.collection("ristoranti")
            .doc(ristoranteId)
            .collection("piatti")
            .onSnapshot(async (snapshot) => {
                for (let change of snapshot.docChanges()) {
                    this.piattoList[change.doc.id] = await this.convertFromFirestoreAsync(change.doc.id, change.doc.data());
                }
                this.notify();
            });
    }

    stopListenPiatti() {
        if (this.listener === undefined) {
            return;
        }
        this.listener();
    }

    convertFromFirestore(documentId: string, mapperObject: any): Promise<Piatto> {
        throw new Error("Method not implemented.");
    }

    notify(): void {
        this.instances.forEach(instance => {
            instance.updatePiattiRistorante(this.piattoList);
        });
    }

    async selectPiattoById(ristoranteId: string, piattoId: string): Promise<Piatto> {
        let docSnapshot = await db.collection("ristoranti").doc(ristoranteId).collection("piatti").doc(piattoId).get();
        let data = this.convertFromFirestoreAsync(docSnapshot.id, docSnapshot.data());
        console.log(data);
        return data;
    }

    async convertFromFirestoreAsync(documentId: string, mapperObject: any): Promise<Piatto> {
        return await Piatto.convertFromFirestore(documentId, mapperObject, true);
    }

    convertToFirestore(mapperObject: Piatto): firebase.firestore.DocumentData {
        return mapperObject.convertToFirestore();
    }

    async selectAllPiatto(ristoranteId: string): Promise<Promise<Piatto>[]> {
        let docSnapshot = await db.collection("ristoranti").doc(ristoranteId).collection("piatti").get();
        let datas = docSnapshot.docs.map(async (doc) => await this.convertFromFirestoreAsync(doc.id, doc.data()));
        return datas;
    }

}